import React, { useCallback, useEffect, useState } from 'react';
import { LaoHero } from '../components/lao/LaoHero';
import { LaoBetDesk } from '../components/lao/LaoBetDesk';
import { LaoHowToPlay } from '../components/lao/LaoHowToPlay';
import { LaoHistory } from '../components/lao/LaoHistory';
import { LaoMyBets } from '../components/lao/LaoMyBets';
import { YikiWalletPanel } from '../components/yiki/YikiWalletPanel';
import { laoService } from '../services/laoService';
import { useAuth } from '../context/AuthContext';
import { useWallet } from '../context/WalletContext';
import { getApiMessage, showError, showSuccess } from '../utils/swal';

const POLL_MS = 4000;

export function LaoPattanaPage() {
  const { isAuthenticated } = useAuth();
  const { balance, setBalance, refreshWallet } = useWallet();
  const [overview, setOverview] = useState(null);
  const [bets, setBets] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const loadOverview = useCallback(() => {
    return laoService
      .getOverview()
      .then((data) => {
        setOverview(data);
        setError('');
      })
      .catch((err) => {
        setError(getApiMessage(err, 'โหลดหวยลาวไม่สำเร็จ'));
      });
  }, []);

  const loadBets = useCallback(() => {
    if (!isAuthenticated) {
      setBets([]);
      return Promise.resolve();
    }
    return laoService
      .getBets({ page: 1, limit: 12 })
      .then((data) => setBets(data.items || data || []))
      .catch(() => {});
  }, [isAuthenticated]);

  useEffect(() => {
    loadOverview();
    loadBets();
    const timer = setInterval(() => {
      loadOverview();
      loadBets();
    }, POLL_MS);
    return () => clearInterval(timer);
  }, [loadOverview, loadBets]);

  const handlePlaceBets = async (payload) => {
    if (!isAuthenticated) {
      await showError({
        title: 'กรุณาเข้าสู่ระบบ',
        text: 'เข้าสู่ระบบก่อนแทงหวยลาว',
      });
      return false;
    }
    setIsSubmitting(true);
    const result = await laoService.placeBets(payload).catch(async (err) => {
      const message = getApiMessage(err, 'แทงหวยลาวไม่สำเร็จ');
      await showError({ title: 'แทงไม่สำเร็จ', text: message });
      return null;
    });

    if (result) {
      setBalance(result.balance);
      await showSuccess({
        title: 'แทงสำเร็จ',
        text: result.message || 'แทงหวยลาวสำเร็จ',
      });
      await Promise.all([loadOverview(), loadBets()]);
      refreshWallet().catch(() => {});
      setIsSubmitting(false);
      return true;
    }

    setIsSubmitting(false);
    return false;
  };

  return (
    <div className="space-y-6">
      {error ? (
        <div className="rounded-xl bg-red-50 px-4 py-3 text-center text-sm text-brand-red">
          {error}
        </div>
      ) : null}

      <LaoHero overview={overview} />

      <div className="grid gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <LaoBetDesk
            config={overview?.config}
            bettingOpen={Boolean(overview?.bettingOpen)}
            balance={balance}
            onPlaceBets={handlePlaceBets}
            isSubmitting={isSubmitting}
          />
        </div>
        <div className="space-y-6">
          <YikiWalletPanel usageHint="แทงหวยลาวหักจากยอดกระเป๋าเว็บไซต์ · ฝาก-ถอนที่หน้ากระเป๋าเงิน" />
          <LaoMyBets bets={Array.isArray(bets) ? bets : []} />
          <LaoHowToPlay config={overview?.config} />
        </div>
      </div>

      <LaoHistory history={overview?.history} />
    </div>
  );
}
